import api from "./index";

// REGISTER
export const registerUser = async (data: {
  name: string;
  email: string;
  password: string;
}) => {
  return api.post("/auth/register", data);
};

// LOGIN
export const loginUser = async (data: { email: string; password: string }) => {
  return api.post("/auth/singin", data);
};

export const sendForgotPasswordOtp = (data: { email: string }) => {
  return api.post("/auth/forget-password", data);
};

export const verifyOtp = (data: { otp: string; email: string }) => {
  return api.post("/auth/verify-otp", data);
};

export const resendOtp = (data: { email: string }) => {
  return api.post("/auth/resend-otp", data);
};

export const resetPassword = (payload: {
  email: string;
  newPassword: string;
}) => {
  return api.post("/auth/reset-password", payload);
};
